import React from 'react';
import './components.css';

const AppError = () => {
    return (
        <div className="container-2025 section-2025">
            <h2>Error</h2>
            <p>Sorry! We just encountered an unexpected error. Please try again.</p>
        </div>
    )
}

export default AppError